module.exports = __webpack_public_path__ + "img/goal.c3acf88b.jpg";